/**
 * The product's mark, as a patient sees it.
 *
 * The same artwork the staff dashboard ships (`laennec-edge-dashboard/public/predixa-logo.png`),
 * copied rather than linked: this SPA is served from its own bucket behind its own distribution and
 * a cross-origin image would be refused by the page's own Content-Security-Policy, which admits
 * `img-src 'self'` and means it.
 *
 * Only the light mark is carried. The dashboard swaps two files by theme; this page has one theme,
 * a white card on slate, and a second file for a dark mode that does not exist would be a file
 * nobody looks at.
 */
export function BrandLogo() {
  return (
    <img
      src="/predixa-logo.png"
      // A patient reading this page with a screen reader is told the company's name once, here, and
      // never again - the mark carries no information the rest of the page does not.
      alt="Predixa Health"
      // No alignment of its own. Where the mark sits is the layout's business - it is centred in a
      // header row pinned to the top of the viewport (scan-flow.tsx) - and `self-start` here was what
      // pulled it to the left edge of a card that no longer bounds it.
      className="h-8 w-auto"
    />
  )
}
